/**
 * P-02: Defer Judge.me widgets until near viewport (or idle).
 * Reduces early main-thread work / Clarity $revWidgets noise.
 */
(function () {
  var SELECTORS = [
    '#judgeme_product_reviews',
    '.jdgm-widget',
    '.jdgm-rev-widg',
    '[id*="judgeme"]',
    'shopify-app-block[type*="judge"]'
  ];

  function isFloating(el) {
    if (!el || !el.classList) return false;
    if (el.classList.contains('jdgm-revs-tab') || el.classList.contains('jdgm-floating-badge')) return true;
    if (el.id === 'jdgm-revs-tab') return true;
    var cls = typeof el.className === 'string' ? el.className : '';
    return cls.indexOf('jdgm-revs-tab') !== -1 || cls.indexOf('floating') !== -1;
  }

  function targets() {
    var nodes = [];
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        // Floating side badge: keep hidden (CSS) and never hydrate early — it slows LCP
        if (isFloating(el)) return;
        if (nodes.indexOf(el) === -1) nodes.push(el);
      });
    });
    return nodes;
  }

  function reveal(el) {
    el.classList.add('rs-jdgm-ready');
    el.style.contentVisibility = 'visible';
    try {
      if (window.jdgm && typeof window.jdgm.customizeWidgets === 'function') {
        window.jdgm.customizeWidgets();
      }
      document.dispatchEvent(new Event('jdgm.doneRefreshingWidgets'));
    } catch (e) {}
  }

  function arm() {
    var list = targets();
    if (!list.length) return;

    list.forEach(function (el) {
      el.classList.add('rs-jdgm-defer');
      el.style.contentVisibility = 'auto';
    });

    if (!('IntersectionObserver' in window)) {
      list.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '200px 0px', threshold: 0.01 }
    );

    list.forEach(function (el) { io.observe(el); });

    // Idle fallback so widgets still hydrate if never scrolled
    var idle = window.requestIdleCallback || function (cb) { setTimeout(cb, 2500); };
    idle(function () {
      targets().forEach(function (el) {
        if (!el.classList.contains('rs-jdgm-ready')) reveal(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();
